import React, { useState } from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Bm10050View from "../../Views/Bases/BM10050";
import Snackbar from "../../Components/Snackbar";
import axios from "axios";
function BM10050(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState();
  const [inputs, setInputs] = React.useState({
    //폼안에 콤보박스
    comboList: [],
    comboValue: "",
    comboPlantList: [],
    comboUnitList: [],
    comboLCatego: [],
    comboMCatego: [],
    comboSCatego: [],
    comboGroup: [],
    comboCatego: [],
    comboWhCd: [],
    //품목 정보(FORM)
    plantCd: "",
    itemCd: "",
    lCatego: "",
    mCatego: "",
    sCatego: "",
    custItemCd: "",
    itemNm: "",
    custCd: "",
    itemUnit: "",
    itemStd1: "",
    itemStd2: "",
    itemPeriodDd: "",
    whCd: "WH_MM_01",
    itemAigingDd: "",
    itemFilePath: "",
    itemFilename: "",
    fileSize: 0,
    itemQcInspYn: "N",
    itemGroup: "",
    itemCatego: "",
    itemType: "",
    projectNm: "",
    itemStdAmt: "",
    itemBomYn: "N",
    itemVatYn: "N",
    remarks: "",
    itemFormula: "1",
    businesCloseDt: "",
    createId: "",
    createDate: "",
    updateId: "",
    updateDate: "",
    //완제품 정보 (FORM)
    personCharg: "",
    userNm: "",
    itemQty: 0,
    soDueDt: "",
    itemWonji1: "",
    itemWonji2: "",
    itemPlateMaking: "",
    itemPrint: "",
    itemRamie: "",
    itemSpecialPrice1: "",
    itemSpecialPrice2: "",
    itemJedae: "",
    itemThompson: "",
    itemString: "",
    itemLaminated: "",
    itemSide: "",
    itemPerforated: "",
    itemVinyl: "",
    itemCarton: "",
    itemHole: "",
    itemCaution: "",
    itemUpperPod: "",
    itemLowPod: "",
  });
  const {
    plantCd,
    itemCd,
    lCatego,
    mCatego,
    sCatego,
    custItemCd,
    itemNm,
    itemUnit,
    itemStd1,
    itemStd2,
    itemPeriodDd,
    itemAigingDd,
    itemQcInspYn,
    itemGroup,
    itemCatego,
    itemType,
    custCd,
    projectNm,
    itemStdAmt,
    itemBomYn,
    itemVatYn,
    itemFormula,
    remarks,
    createId,
    createDate,
    updateId,
    updateDate,
    //완제품 정보 (FORM)
    personCharg,
    userNm,
    itemQty,
    soDueDt,
    itemWonji1,
    itemWonji2,
    itemPlateMaking,
    itemPrint,
    itemRamie,
    itemSpecialPrice1,
    itemSpecialPrice2,
    itemJedae,
    itemThompson,
    itemString,
    itemLaminated,
    itemSide,
    itemPerforated,
    itemVinyl,
    itemCarton,
    itemHole,
    itemCaution,
    itemUpperPod,
    itemLowPod,
  } = inputs;

  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [checkItemCdToggle, setCheckItemCdTolle] = React.useState(false);
  const [authGroupGridRowData, setAuthGroupGridRowData] = React.useState([]);
  const [authGroupGridUserData, setAuthGroupGridUserData] = React.useState([]);
  const [modalToggle, setModalToggle] = React.useState(false);
  const [checkInputs, setCheckInputs] = React.useState({
    comboExport: [],
    exportValue: "E",
    comboRegion: [],
    regionValue: "B",
    comboCustomer: [],
    customerValue: "SD",
  });
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getComboData = [];
    let getComboData1 = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);
      //창고코드 콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetWh,
        {
          whCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        getComboData1.push({
          value: "",
          name: "선택",
        });
        for (let i = 0; i < data.length; i++) {
          getComboData1.push({
            value: data[i].value,
            name: data[i].name,
          });
        }
        inputs.comboWhCd = {
          value: "",
          name: "",
        };
        inputs.comboWhCd = getComboData1;
      });
      //콤보박스
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCode,
        {
          groupCd: "string",
        }
      ).then((result) => {
        let data = result.data;
        getComboData.push({
          value: "",
          name: "선택",
        });
        for (let i = 0; i < data.length; i++) {
          getComboData.push({
            groupCd: data[i].GroupCd,
            value: data[i].Code,
            name: data[i].Name,
          });
        }

        inputs.comboList = getComboData.filter((e) => e.groupCd == "ITEM_TYPE");

        checkInputs.comboExport = getComboData.filter(
          (e) => e.groupCd == "EXPORT_CD" && e.value != "EXPORT_CD"
        );
        checkInputs.comboRegion = getComboData.filter(
          (e) => e.groupCd == "ORDER_REGION" && e.value != "ORDER_REGION"
        );
        checkInputs.comboCustomer = getComboData.filter(
          (e) => e.groupCd == "CUSTOMER_CODE" && e.value != "CUSTOMER_CODE"
        );
        inputs.comboPlantList = getComboData.filter(
          (e) =>
            (e.groupCd == "PLANT_CD" && e.value != "PLANT_CD") || e.value == ""
        );
        inputs.comboUnitList = getComboData.filter(
          (e) =>
            (e.groupCd == "ITEM_UNIT" && e.value != "ITEM_UNIT") ||
            e.value == ""
        );
        inputs.comboLCatego = getComboData.filter(
          (e) =>
            (e.groupCd == "L_CATEGO" && e.value != "L_CATEGO") || e.value == ""
        );
        inputs.comboMCatego = getComboData.filter(
          (e) =>
            (e.groupCd == "M_CATEGO" && e.value != "M_CATEGO") || e.value == ""
        );
        inputs.comboSCatego = getComboData.filter(
          (e) =>
            (e.groupCd == "S_CATEGO" && e.value != "S_CATEGO") || e.value == ""
        );
        inputs.comboCatego = getComboData.filter(
          (e) => (e.groupCd == "CATEGO" && e.value != "CATEGO") || e.value == ""
        );
        inputs.comboGroup = getComboData.filter(
          (e) =>
            (e.groupCd == "ITEM_GROUP" && e.value != "ITEM_GROUP") ||
            e.value == ""
        );
      });

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10050.GetItemMst
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              createDate: data[i].createDate
                ? Commons.DateFormating(data[i].createDate.toString(), 2)
                : "",
              createId: data[i].createId,
              custItemCd: data[i].custItemCd,
              itemAigingDd: data[i].itemAigingDd,
              itemBomYn: data[i].itemBomYn,
              itemCatego: data[i].itemCatego,
              itemCd: data[i].itemCd,
              custCd: data[i].custCd,
              custNm: data[i].custNm,
              itemGroup: data[i].itemGroup,
              itemNm: data[i].itemNm,
              whCd: data[i].whCd,
              whNm: data[i].whNm,
              itemPeriodDd: data[i].itemPeriodDd
                ? new Date(data[i].itemPeriodDd)
                : null,
              itemQcInspYn: data[i].itemQcInspYn,
              itemVatYn: data[i].itemVatYn,
              itemStd1: data[i].itemStd1,
              itemStd2: data[i].itemStd2,
              itemFilePath: data[i].itemFilePath,
              itemFilename: data[i].itemFilename,
              catonInQty: data[i].catonInQty,
              itemStdAmt: data[i].itemStdAmt,
              itemType: data[i].itemType,
              itemTypeNm: data[i].itemTypeNm,
              itemUnit: data[i].itemUnit,
              itemUnitNm: data[i].itemUnitNm,
              lCatego: data[i].lCatego,
              lCategoNm: data[i].lCategoNm,
              mCatego: data[i].mCatego,
              mCategoNm: data[i].mCategoNm,
              sCatego: data[i].sCatego,
              sCategoNm: data[i].sCategoNm,
              plantCd: data[i].plantCd,
              plantNm: data[i].plantNm,
              projectNm: data[i].projectNm,
              remarks: data[i].remarks,
              itemFormula: data[i].itemFormula,
              updateDate: data[i].updateDate
                ? Commons.DateFormating(data[i].updateDate.toString(), 2)
                : "",
              updateId: data[i].updateId,
              //완제품 정보
              personCharg: data[i].personCharg,
              userNm: data[i].userNm,
              itemQty: data[i].itemQty,
              soDueDt: data[i].soDueDt,
              itemWonji1: data[i].itemWonji1,
              itemWonji2: data[i].itemWonji2,
              itemPlateMaking: data[i].itemPlateMaking,
              itemPrint: data[i].itemPrint,
              itemRamie: data[i].itemRamie,
              itemSpecialPrice1: data[i].itemSpecialPrice1,
              itemSpecialPrice2: data[i].itemSpecialPrice2,
              itemJedae: data[i].itemJedae,
              itemThompson: data[i].itemThompson,
              itemString: data[i].itemString,
              itemLaminated: data[i].itemLaminated,
              itemSide: data[i].itemSide,
              itemPerforated: data[i].itemPerforated,
              itemVinyl: data[i].itemVinyl,
              itemCarton: data[i].itemCarton,
              itemHole: data[i].itemHole,
              itemCaution: data[i].itemCaution,
              itemUpperPod: data[i].itemUpperPod,
              itemLowPod: data[i].itemLowPod,
            });
          }

          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //거래처 헬퍼
  const CustNmHelper = async (_custCd) => {
    Dialog.ProgressBar(true);
    let getRowData = [];
    let getData = [];

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetCustList,
        {
          plantCd: "string",
          value: _custCd === "" ? "string" : _custCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              custNm: data[i].custNm,
              custCd: data[i].custCd,
              // arrivCustCd: data[i].arrivCustCd,
              arrivCustCd: data[i].custNm,
            });
          }
          setAuthGroupGridRowData(getData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //담당자 헬퍼
  const UserNmHelper = async (_userId) => {
    Dialog.ProgressBar(true);
    let getRowData = [];
    let getData = [];

    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Common.GetUserList,
        { value: _userId === "" ? "string" : _userId }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getData.push({
              userId: data[i].userId,
              userNm: data[i].userNm,
            });
          }
          setAuthGroupGridUserData(getData);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const CheckCusCd = async () => {
    Dialog.ProgressBar(true);
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10050.CheckItemCd,
        {
          export: checkInputs.exportValue,
          region: checkInputs.regionValue,
          customer: checkInputs.customerValue,
        }
      ).then((result) => {
        let data = result.data;
        setInputs({
          ...inputs,
          itemCd: data,
        });
        if (data === true) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_UseokItemCd" && f.lanType === "SNACK"
            )[0].lanName,
          });
          setCheckItemCdTolle(true);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SaveConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        SaveLogic();
      }
    );
  };
  //파일업로드
  const FileConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        FileLogic();
      }
    );
  };
  //파일업로드
  const FileLogic = async () => {
    const formData = new FormData();
    if (file == undefined) {
      setSnackbars({
        toggle: true,
        type: "info",
        message: "파일을 선택하세요.",
      });
      return false;
    } else {
      formData.append("formFile", file);
      formData.append("fileName", fileName);
      formData.append("itemCd", inputs.itemCd);
      formData.append("filePath", inputs.itemFilePath);
    }

    try {
      await axios
        .post(
          Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.FileSave,
          formData
        ) //로컬
        // .post("https://dongsungprintingmes.com:8080/BM10040/FileSave", formData) //운영
        //.post("http://114.206.84.134:5540/BM10040/FileSave", formData); //테스트

        .then((result) => {
          if (result.data == "success") {
            //파일업로드 성공
            setSnackbars({
              toggle: true,
              type: "info",
              message: lanData.filter(
                (f) => f.lanId === "Snack_FileUpload" && f.lanType === "SNACK"
              )[0].lanName,
            });
            Init();
          } else {
            //파일업로드 실패
            setSnackbars({
              toggle: true,
              type: "error",
              message: lanData.filter(
                (f) =>
                  f.lanId === "Snack_FileUploadFail" && f.lanType === "SNACK"
              )[0].lanName,
            });
          }
        });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //다운로드
  const FileDownConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Save" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        FileDownLogic();
      }
    );
  };
  //다운로드
  const FileDownLogic = async () => {
    let fileName = inputs.fileName;
    try {
      // await axios
      //   .post("https://localhost:7117/BM10040/FileDownload", {
      //     fileName: fileNmae,
      //   }) //로컬
      // .post("https://dongsungprintingmes.com:8080/BM10040/FileSave", formData) //운영
      //.post("http://114.206.84.134:5540/BM10040/FileSave", formData); //테스트
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.FileDownload,
        {
          fileName: inputs.itemFilename,
        }
      ).then((result) => {
        if (result.data.message == "success") {
          //파일다운로드 성공
          saveAs(result.data.data, inputs.itemFilename);

          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_FileDownload" && f.lanType === "SNACK"
            )[0].lanName,
          });
          Init();
        } else {
          //파일다운로드 실패
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) =>
                f.lanId === "Snack_FileDownloadFail" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  //파일삭제
  const FileDeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        FileDeleteLogic();
      }
    );
  };
  //파일삭제
  const FileDeleteLogic = async () => {
    if (inputs.itemFilename == "" || inputs.itemFilename == undefined) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: "등록된 파일이 없습니다.",
      });
      return false;
    }
    try {
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Bases.BM10040.FileDelete,
        {
          value: inputs.itemCd,
          chkIndex: "1",
          fileName: inputs.itemFilename,
        }
      ).then((result) => {
        if (result.data == "success") {
          //파일삭제 성공
          setSnackbars({
            toggle: true,
            type: "info",
            message: lanData.filter(
              (f) => f.lanId === "Snack_FileUpload" && f.lanType === "SNACK"
            )[0].lanName,
          });
          Init();
        } else {
          //파일삭제 실패
          setSnackbars({
            toggle: true,
            type: "error",
            message: lanData.filter(
              (f) => f.lanId === "Snack_FileUploadFail" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };
  const saveAs = async (blob, fileName) => {
    //base to blod
    const byteCharacters = atob(blob);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob2 = new Blob([byteArray]);
    var link = document.createElement("a");
    link.href = URL.createObjectURL(blob2);
    link.download = fileName;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const SaveLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = null;

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      // if (inputs.itemFilePath != null && inputs.itemFilename != null) {
      //   FileLogic();
      // }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10050.CreateItemMst,
        {
          plantCd: plantCd,
          itemCd: itemCd,
          lCatego: lCatego,
          mCatego: mCatego,
          sCatego: sCatego,
          custItemCd: custItemCd,
          itemNm: itemNm,
          itemUnit: itemUnit,
          itemStd1: itemStd1,
          itemStd2: itemStd2,
          itemPeriodDd: !inputs.itemPeriodDd
            ? null
            : Commons.DateStrChange(inputs.itemPeriodDd),
          itemAigingDd: !inputs.itemAigingDd ? 0 : inputs.itemAigingDd,
          itemQcInspYn: itemQcInspYn,
          itemGroup: itemGroup,
          itemCatego: itemCatego,
          whCd: inputs.whCd,
          custCd: custCd,
          itemType: itemType,
          projectNm: projectNm,
          itemStdAmt: !inputs.itemStdAmt ? 0 : inputs.itemStdAmt,
          itemBomYn: itemBomYn,
          itemVatYn: itemVatYn,
          remarks: remarks,
          itemFormula: itemFormula,
          cartonQuantity: inputs.catonInQty,
          createId: userInfo.userId,
          //createDate: new Date(),
          updateId: userInfo.userId,
          //updateDate: new Date(),
          //완제품정보
          personCharg: personCharg,
          itemQty: itemQty,
          soDueDt: soDueDt,
          itemWonji1: itemWonji1,
          itemWonji2: itemWonji2,
          itemPlateMaking: itemPlateMaking,
          // itemFilePath: inputs.itemFilePath,
          itemFilename: inputs.itemFilename,
          itemPrint: itemPrint,
          itemRamie: itemRamie,
          itemSpecialPrice1: itemSpecialPrice1,
          itemSpecialPrice2: itemSpecialPrice2,
          itemJedae: itemJedae,
          itemThompson: itemThompson,
          itemString: itemString,
          itemLaminated: itemLaminated,
          itemSide: itemSide,
          itemPerforated: itemPerforated,
          itemVinyl: itemVinyl,
          itemCarton: itemCarton,
          itemHole: itemHole,
          itemCaution: itemCaution,
          itemUpperPod: itemUpperPod,
          itemLowPod: itemLowPod,
        }
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Save" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const DeleteConfirm = () => {
    Dialog.Confirm(
      lanData.filter(
        (f) => f.lanId === "Dia_Title_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Message_Delete" && f.lanType === "DIALOG"
      )[0].lanName,
      lanData.filter(
        (f) => f.lanId === "Dia_Btn_Confirm" && f.lanType === "DIALOG"
      )[0].lanName,
      () => {
        DeleteLogic();
      }
    );
  };

  const DeleteLogic = async () => {
    Dialog.ProgressBar(true);
    let userInfo = {};
    let deleteData = [];

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        userInfo = result;
      });
      for (let i = 0; i < selectedRowData.length; i++) {
        deleteData.push({
          plantCd: selectedRowData[i].plantCd,
          itemCd: selectedRowData[i].itemCd,
        });
      }
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Bases.BM10050.DeleteItemMst,
        deleteData
      ).then((result) => {
        let data = result.data;

        if (data !== "Ok") {
          setSnackbars({
            toggle: true,
            type: "error",
            message: data,
          });
        } else {
          Init();
          setSnackbars({
            toggle: true,
            type: "success",
            message: lanData.filter(
              (f) => f.lanId === "Snack_Delete" && f.lanType === "SNACK"
            )[0].lanName,
          });
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const ResetItemCd = () => {
    setInputs({
      ...inputs,
      plantCd: "",
      itemCd: "",
      lCatego: "",
      mCatego: "",
      custItemCd: "",
      itemNm: "",
      itemUnit: "",
      itemStd1: "",
      itemStd2: "",
      itemPeriodDd: "",
      itemAigingDd: "",
      itemQcInspYn: "",
      itemGroup: "",
      itemCatego: "",
      itemType: "",
      projectNm: "",
      itemStdAmt: "",
      itemBomYn: "",
      remarks: "",
    });
  };

  return (
    <>
      <Bm10050View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        selectedRowData={selectedRowData}
        setSelectedRowData={setSelectedRowData}
        setInputs={setInputs}
        // comboList={comboList}
        inputs={inputs}
        SaveConfirm={SaveConfirm}
        DeleteConfirm={DeleteConfirm}
        setModalToggle={setModalToggle}
        modalToggle={modalToggle}
        setCheckInputs={setCheckInputs}
        setCheckItemCdTolle={setCheckItemCdTolle}
        FileDownConfirm={FileDownConfirm}
        checkItemCdToggle={checkItemCdToggle}
        FileConfirm={FileConfirm}
        FileDeleteConfirm={FileDeleteConfirm}
        setAuthGroupGridRowData={setAuthGroupGridRowData}
        authGroupGridRowData={authGroupGridRowData}
        authGroupGridUserData={authGroupGridUserData}
        setAuthGroupGridUserData={setAuthGroupGridUserData}
        checkInputs={checkInputs}
        CustNmHelper={CustNmHelper}
        ResetItemCd={ResetItemCd}
        CheckCusCd={CheckCusCd}
        UserNmHelper={UserNmHelper}
        file={file}
        setFile={setFile}
        fileName={fileName}
        setFileName={setFileName}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default BM10050;
